import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Construction, Mail, Clock } from 'lucide-react';

export function MaintenancePage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-lg text-center shadow-lg">
        <CardHeader className="space-y-4">
          <div className="mx-auto w-16 h-16 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center">
            <Construction className="h-8 w-8 text-amber-600 dark:text-amber-400" aria-hidden="true" />
          </div>
          <CardTitle className="text-3xl font-bold tracking-tight">
            We'll be back soon
          </CardTitle>
          <CardDescription className="text-base">
            WealthVantage ADT is temporarily unavailable while we perform maintenance.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="flex items-center justify-center gap-2 text-muted-foreground">
            <Clock className="h-4 w-4" aria-hidden="true" />
            <span>Expected return: to be advised</span>
          </div>
          
          <div className="rounded-lg bg-muted p-4 text-sm text-muted-foreground">
            <p>
              Thank you for your patience. If you need urgent assistance, please contact us at{' '}
              <a 
                href="mailto:support@wealthvantagepartners.com" 
                className="inline-flex items-center gap-1 font-medium text-foreground hover:underline"
              >
                <Mail className="h-3 w-3" aria-hidden="true" />
                support@wealthvantagepartners.com
              </a>
            </p>
          </div>

          <p className="text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} WealthVantage Partners. All rights reserved.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}

export default MaintenancePage;
